<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'
             title="Thêm mới"
             type="orange"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model.trim="model.application" form-group-class="col-md-6 col-sm-6" label="Application" validate-rules="required"/>
      <c-input v-model.trim="model.profile" form-group-class="col-md-6 col-sm-6" label="Profile" validate-rules="required"/>
      <c-input v-model.trim="model.label" form-group-class="col-md-6 col-sm-6" label="Label" validate-rules="required"/>
      <c-input v-model.trim="model.key" form-group-class="col-md-6 col-sm-6" label="Key" validate-rules="required"/>
      <c-input v-model.trim="model.value" form-group-class="col-md-12 col-sm-12" label="Value"/>
      <c-select2 v-model="model.isActive"
                 label="Đang hoạt động"
                 form-group-class="col-md-6 col-sm-6"
                 validate-rules="required"
      >
        <option value="true">true</option>
        <option value="false">false</option>
      </c-select2>
    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        id: null,
        application: null,
        profile: null,
        label: null,
        key: null,
        value: null,
        isActive: null,
      },
    }
  },
  methods: {
    open(id) {
      this.show = true;
      this.model = {
        id: null,
        application: null,
        profile: null,
        label: null,
        key: null,
        value: null,
        isActive: null,
      }
      this.getData(id);
    },
    getData(id) {
      this.$http
          .get(`/cms/api/v1.0/system-config-properties/${id}`)
          .then(successRes => {
            let data = successRes.data;
            this.model.id = data.id;
            this.model.application = data.application;
            this.model.profile = data.profile;
            this.model.label = data.label;
            this.model.key = data.key;
            this.model.value = data.value;
            this.model.isActive = data.isActive ? "true" : "false";
          }, errorRes => {
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes));
            this.$stopLoader();
          });
    },
    submit() {
      this.$showLoader();
      let data = {
        "application": this.model.application,
        "profile": this.model.profile,
        "label": this.model.label,
        "key": this.model.key,
        "value": this.model.value,
        "isActive": this.model.isActive,
      }
      this.$http
          .put(`/cms/api/v1.0/system-config-properties/${this.model.id}`, data)
          .then(successRes => {
            this.close();
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          }, errorRes => {
            this.$stopLoader();
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes));
            this.$emit("error", errorRes);
          })
      ;
    }
  }
}
</script>

<style scoped>

</style>